import styled from "styled-components";


const AppWrapper = styled.div`
background-image: linear-gradient(-20deg, #ff2846 0%, #6944ff 100%);
background-position: center;
background-size: cover;
height: 100%;
min-height: 100vh;
background-attachment: fixed;
width: 100vw;
display: flex;
justify-content: center;
align-items: center;
`
export default AppWrapper